import {
  loadCatalogVersions,
  saveCatalogVersions,
  saveCategories,
  saveSubcategories,
  saveQuests,
} from './catalogCache';
import { request } from '../api/http';

export async function syncCatalogIfChangedWeb() {
  const known = await loadCatalogVersions();

  const [cats, subs, quests] = await Promise.all([
    request('/public/quest-categories', { method: 'GET', auth: false }).catch(() => null),
    request('/public/quest-subcategories', { method: 'GET', auth: false }).catch(() => null),
    request('/public/quests', { method: 'GET', auth: false }).catch(() => null),
  ]);

  const nextVersions: Record<string, string | undefined> = { ...known };

  if (cats?.items?.length && cats.rev !== known.categoriesRev) {
    await saveCategories(cats.rev, cats.items);
    nextVersions.categoriesRev = cats.rev;
  }

  if (subs?.items?.length && subs.rev !== known.subcategoriesRev) {
    await saveSubcategories(subs.rev, subs.items);
    nextVersions.subcategoriesRev = subs.rev;
  }

  if (quests?.items?.length && quests.rev !== known.questsRev) {
    await saveQuests(quests.rev, quests.items);
    nextVersions.questsRev = quests.rev;
  }

  nextVersions.lastSyncAt = String(Date.now());
  await saveCatalogVersions(nextVersions);
}
